import {
  DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
  DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
  RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
  LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
  NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DOWNLOADSAMPLEFILEOFCURRENCYRATE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case DOWNLOADSAMPLEFILEOFCURRENCYRATE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case DOWNLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_DOWNLOADSAMPLEFILEOFCURRENCYRATE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_DOWNLOADSAMPLEFILEOFCURRENCYRATE:
      return (state = initialState);
    default:
      return state;
  }
};
